export default {
  ADD_NOTIFICATION_TO_QUEUE: 'ADD_NOTIFICATION_TO_QUEUE',
  REMOVE_NOTIFICATION_TO_QUEUE: 'REMOVE_NOTIFICATION_TO_QUEUE',
  MARK_NOTIFICATION_FOR_REMOVE: 'MARK_NOTIFICATION_FOR_REMOVE',
}
